import React, { useEffect, useState } from 'react';
import api from '../../../../config/axios';

import CentroDeCustoModal from './modals/CentroDeCusto';
import Paginacao from '../../../../components/utils/paginacao';

import { FaPlus, FaEdit, FaFilter, FaTrashAlt, FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const CentrosDeCusto = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const [centrosDeCusto, setCentrosDeCusto] = useState([]);
  const [filtroNome, setFiltroNome] = useState('');
  const [filtroAbrangencia, setFiltroAbrangencia] = useState('');

  const [selectedCentroDeCusto, setSelectedCentroDeCusto] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const limit = 10;

  const fetchCentrosDeCusto = async (currentPage) => {
    try {
      Swal.fire({
        title: 'Carregando...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const params = {
        page: currentPage,
        limit: limit,
        nome: filtroNome,
        abrangencia: filtroAbrangencia
      };

      const response = await api.get('/centros-de-custo', { params });

      setCentrosDeCusto(response.data.records || []);
      setTotalPages((Math.ceil(response.data.totalRegistros / limit)) || 1);
      setTotalRegistros(response.data.totalRegistros || 0); 
      setError(null);
    } catch (err) {
      setError('Erro ao carregar os dados. Tente novamente mais tarde.');
    } finally {
      Swal.close();
    }
  };

  useEffect(() => {
    fetchCentrosDeCusto(currentPage);
  }, [currentPage]);

  const handlePageChange = (currentPage) => {
    setCurrentPage(currentPage);
  };

  const handleAddCentroDeCusto = () => {
    setSelectedCentroDeCusto(null);
    setIsModalOpen(true);
  };

  const handleEditCentroDeCusto = (centroDeCusto) => {
    setSelectedCentroDeCusto(centroDeCusto);
    setIsModalOpen(true);
  };

  const handleDeleteCentroDeCusto = async (centroDeCusto) => {
    const result = await Swal.fire({
      title: 'Tem certeza?',
      text: `Deseja excluir o centro de custo "${centroDeCusto.nome}"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, excluir!',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      try {
        await api.delete(`/centros-de-custo/${centroDeCusto.id}`);
        Swal.fire('Excluído!', 'Centro de custo foi excluído com sucesso.', 'success');
        fetchCentrosDeCusto(currentPage);
      } catch (error) {
        Swal.fire('Erro!', error.response.data.message || 'Não foi possível excluir o centro de custo.', 'error');
      }
    }
  };

  const handleFiltrar = () => {
    setCurrentPage(1);
    fetchCentrosDeCusto(1);
  };

  const handleLimparFiltros = () => {
    setFiltroNome('');
    setFiltroAbrangencia('');
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedCentroDeCusto(null);
  };

  const handleCentroDeCustoAtualizado = () => {
    fetchCentrosDeCusto(currentPage);
    handleModalClose();
  };

  const getAbrangenciaLabel = (abrangencia) => {
    const abrangencias = {
      'gestora': 'Gestora',
      'unidade': 'Unidade'
    };
    return abrangencias[abrangencia] || abrangencia;
  };

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12">
              <div className="d-flex align-items-center">
                <button
                  className="btn btn-outline-secondary me-3"
                  onClick={() => navigate('/financeiro/cadastros')}
                  title="Voltar para Cadastros"
                >
                  <FaArrowLeft />
                </button>
                <h4 className="fw-bold mb-0">Centros de Custo</h4>
              </div>
            </div>
          </div>
          <div className="row mt-3 mb-3">
            <div className="col-md-6 col-12">
              <button className="btn btn-outline-primary" onClick={handleAddCentroDeCusto}>
                <FaPlus /> Adicionar Centro de Custo
              </button>
            </div>
          </div>

          <div className="row mt-4 mb-4">
            <div className="col-lg-4 col-12">
              <label className="form-label fw-bold">Nome</label>
              <input
                type="text"
                autoComplete="off"
                placeholder="Digite o nome do centro de custo"
                value={filtroNome}
                className="form-control"
                onChange={(e) => setFiltroNome(e.target.value.toUpperCase())}
              />
            </div>
            <div className="col-lg-3 col-12 mt-lg-0 mt-3">
              <label className="form-label fw-bold">Abrangência</label>
              <select
                value={filtroAbrangencia}
                className="form-control"
                onChange={(e) => setFiltroAbrangencia(e.target.value)}
              >
                <option value="">Todas as abrangências</option>
                <option value="gestora">Gestora</option>
                <option value="unidade">Unidade</option>
              </select>
            </div>
            <div className="col-lg-5 col-12 mt-lg-0 mt-3 d-flex align-items-end">
              <div className="d-flex gap-2 w-100 justify-content-end">
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleLimparFiltros}
                >
                  Limpar
                </button>
                <button
                  className="btn btn-custom-primary"
                  onClick={handleFiltrar}
                >
                  <FaFilter /> Filtrar
                </button>
              </div>
            </div>
          </div>

          {error ? (
            <p className="error-message">{error}</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped">
                <thead className="table-custom-primary">
                  <tr>
                    <th className="text-nowrap">Nome</th>
                    <th className="text-nowrap">Abrangência</th>
                    <th className="text-nowrap">Gestora</th>
                    <th className="text-nowrap">Unidade</th>
                    <th className="text-center">Ativo</th>
                    <th className="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {centrosDeCusto.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center">
                        Nenhum centro de custo encontrado.
                      </td>
                    </tr>
                  ) : (
                    centrosDeCusto.map((centroDeCusto, index) => (
                      <tr key={index}>
                        <td className="text-nowrap">{centroDeCusto.nome}</td>
                        <td className="text-nowrap">
                          <span className={`badge ${centroDeCusto.abrangencia === 'gestora' ? 'bg-primary' : 'bg-info'
                            }`}>
                            {getAbrangenciaLabel(centroDeCusto.abrangencia)}
                          </span>
                        </td>
                        <td className="text-nowrap">{centroDeCusto.gestora?.nome || 'N/A'}</td>
                        <td className="text-nowrap">{centroDeCusto.unidade?.nome || 'N/A'}</td>
                        <td className="text-center">
                          {centroDeCusto.ativo ? (
                            <span className="fw-bold">Sim</span>
                          ) : (
                            <span className="fw-bold">Não</span>
                          )}
                        </td>
                        <td className="text-center">
                          <div className="d-flex gap-2 justify-content-center">
                            <button
                              className="btn btn-custom-secondary btn-sm"
                              onClick={() => handleEditCentroDeCusto(centroDeCusto)}
                              title="Editar"
                            >
                              <FaEdit />
                            </button>
                            <button
                              className="btn btn-custom-secondary btn-sm ms-3"
                              onClick={() => handleDeleteCentroDeCusto(centroDeCusto)}
                              title="Excluir"
                            >
                              <FaTrashAlt />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}

          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="mb-3">
              <span>
                Total de registros: <strong>{totalRegistros}</strong>
              </span>
            </div>
            <Paginacao
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>

      {isModalOpen && (
        <CentroDeCustoModal
          centroDeCusto={selectedCentroDeCusto}
          onClose={handleModalClose}
          onCentroDeCustoAtualizado={handleCentroDeCustoAtualizado}
        />
      )}
    </div>
  );
};

export default CentrosDeCusto; 